import { memo, useState } from "react";

import { validateEmailAddress } from "@react/utilities";
import { klaviyoSubscribe } from "@root/tablescape/utilities";
import { FooterEmailFormView } from "@sections/Footer/FooterEmailForm/FooterEmailForm.view";

export type EmailFormProps = {
  errorMessage: string;
  footerEmailFormLabel: string;
  listId: string;
  placeholder: string;
  successMessage: string;
};

const FooterEmailFormBase = ({
  errorMessage,
  footerEmailFormLabel,
  listId,
  placeholder,
  successMessage,
}: EmailFormProps) => {
  const [inputText, setInputText] = useState<string>("");
  const [isFormValid, setIsFormValid] = useState<boolean>(true);
  const [placeholderText, setPlaceholderText] = useState<string>(placeholder);
  const [submitted, setSubmitted] = useState<boolean>(false);

  const handleChange = (
    e: React.SyntheticEvent & { target: HTMLInputElement }
  ) => setInputText(e.target.value);

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (!validateEmailAddress(inputText)) {
      setIsFormValid(false);
      return;
    }

    setIsFormValid(true);
    klaviyoSubscribe(listId, inputText, {
      customSource: footerEmailFormLabel,
    }).then((res) => {
      if (res?.ok) {
        setSubmitted(true);
        setInputText("");
        setPlaceholderText(successMessage);
      }
    });
  };

  return (
    <FooterEmailFormView
      inputText={inputText}
      invalidHelperText={errorMessage}
      isFormValid={isFormValid}
      onChange={handleChange}
      onSubmit={handleSubmit}
      placeholder={placeholderText}
      submitted={submitted}
    />
  );
};

export const FooterEmailForm = memo(FooterEmailFormBase);
